export class Image {
    static preloadImages(paths: Array<string>): Promise<HTMLImageElement[]> {
        const proms = new Array<Promise<HTMLImageElement>>();
        for (const i in paths) proms.push(Image.preloadImage(paths[i]));

        return Promise.all(proms);
    }

    static preloadImage(path: string): Promise<HTMLImageElement> {
        return new Promise((s) => {
            const image = document.createElement("img");
            image.addEventListener("load", () => {
                s(image);
            });

            image.addEventListener("error", () => {
                s(undefined as any);
            });

            image.setAttribute("src", path);
        });
    }
}
